import { createContext } from "react";
import type { UseQueryResult } from "react-query";

import type {
  MalnutritionRiskAssessment,
  PatientWeightHistory,
} from "../../types/Malnutrition";

export interface MalnutritionAPIContextValue {
  emrPatientID: string;
  emrHospitalID: string;
  riskAssessmentQuery: UseQueryResult<MalnutritionRiskAssessment, Error> | null;
  weightsQuery: UseQueryResult<PatientWeightHistory, Error> | null;
}

const MalnutritionAPIContext = createContext<MalnutritionAPIContextValue>({
  emrPatientID: "",
  emrHospitalID: "",
  riskAssessmentQuery: null,
  weightsQuery: null,
});

export default MalnutritionAPIContext;
